export default __webpack_public_path__ + "static/james-bitmoji-34f5db9c4e3f665ee5cea1a786d4b551.png";